import React from 'react';
import {CloseButton, Flex, Input, Text} from '@chakra-ui/react';
import {NumericFormat} from 'react-number-format';
import {FilterSelect} from './FilterSelect';

interface NumberRange {
  min?: number;
  max?: number;
}

const filterSelectionOptions = {
  btw: {label: 'between', value: 'btw'},
};

export const NumberFilterControl = ({
  value,
  onChange,
  onRemove,
  format = 'number',
}: {
  value: NumberRange;
  onChange: (value: NumberRange) => void;
  onRemove: () => void;
  format?: 'number' | 'currency';
}) => {
  const isInvalid =
    value.max !== undefined && value.min !== undefined && value.max < value.min;

  return (
    <Flex gap="2" flex={2} alignItems="center">
      <FilterSelect
        variant="operator"
        options={Object.values(filterSelectionOptions)}
        value={filterSelectionOptions.btw}
      />
      <NumericFormat
        customInput={Input}
        value={value.min ?? ''}
        onValueChange={(values) => onChange({...value, min: values.floatValue})}
        thousandSeparator=","
        prefix={format === 'currency' ? '$' : ''}
        placeholder="Min"
        fontSize="sm"
        p={1}
        isInvalid={isInvalid}
        allowNegative={false}
        decimalScale={0}
      />
      <Text color={'kgray.300'}>and</Text>
      <NumericFormat
        customInput={Input}
        value={value.max ?? ''}
        onValueChange={(values) => onChange({...value, max: values.floatValue})}
        thousandSeparator=","
        prefix={format === 'currency' ? '$' : ''}
        placeholder="Max"
        fontSize="sm"
        p={1}
        isInvalid={isInvalid}
        allowNegative={false}
        decimalScale={0}
      />
      <CloseButton onClick={onRemove} />
    </Flex>
  );
};
